module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('p', {
    staticClass: "content"
  }, [_c('b', [_vm._v("selected")]), _vm._v(": " + _vm._s(_vm.selectedOptions))]), _vm._v(" "), _c('b-dropdown', {
    attrs: {
      "multiple": "",
      "aria-role": "list"
    },
    model: {
      value: (_vm.selectedOptions),
      callback: function($$v) {
        _vm.selectedOptions = $$v
      },
      expression: "selectedOptions"
    }
  }, [_c('button', {
    staticClass: "button is-primary",
    attrs: {
      "slot": "trigger",
      "type": "button"
    },
    slot: "trigger"
  }, [_c('span', [_vm._v("Selected (" + _vm._s(_vm.selectedOptions.length) + ")")]), _vm._v(" "), _c('b-icon', {
    attrs: {
      "icon": "menu-down"
    }
  })], 1), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "value": "option1",
      "aria-role": "listitem"
    }
  }, [_c('span', [_vm._v("Option 1")])]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "value": "option2",
      "aria-role": "listitem"
    }
  }, [_c('span', [_vm._v("Option 2")])]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "value": "option3",
      "aria-role": "listitem"
    }
  }, [_c('span', [_vm._v("Option 3")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a516cf14"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/dropdown/examples/ExCustomizeMultiple.vue
// module id = 1072
// module chunks = 11 133